import { render, staticRenderFns } from "./CKDirect.vue?vue&type=template&id=1ca3a784&scoped=true"
import script from "./CKDirect.vue?vue&type=script&lang=js"
export * from "./CKDirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca3a784",
  null
  
)

export default component.exports